// src/Notes/NotesContent/Probability/kl-divergence.js

const klDivergence = String.raw`
### Definition
The **Kullback–Leibler divergence** (relative entropy) measures how one probability distribution $P$
differs from a reference distribution $Q$.

$$
D_{\text{KL}}(P \parallel Q) = \sum_{x \in \mathcal{X}} P(x) \log \left( \frac{P(x)}{Q(x)} \right)
$$
for continous distributions, the sum is replaced by an integral:
$$
D_{\text{KL}}(P \parallel Q) = \int_{x \in \mathcal{X}} P(x) \log \left( \frac{P(x)}{Q(x)} \right) dx
$$  

### Properties

- **Non-negative**: $D_{\text{KL}}(P \parallel Q) \ge 0$
<details>
<summary>Proof</summary>

The proof uses **Jensen's Inequality** ($\ln x \le x - 1$).

$$
\begin{aligned}
-D_{\text{KL}}(P \parallel Q) &= - \sum P(x) \log \frac{P(x)}{Q(x)} \\
&= \sum P(x) \log \frac{Q(x)}{P(x)} \\
&\le \log \left( \sum P(x) \frac{Q(x)}{P(x)} \right) \\
&= \log \left( \sum Q(x) \right) = \log(1) = 0
\end{aligned}
$$

Multiplying by $-1$ reverses the inequality:
$$ D_{\text{KL}}(P \parallel Q) \ge 0 $$

</details>

- **Asymmetric**: $D_{\text{KL}}(P \parallel Q) \neq D_{\text{KL}}(Q \parallel P)$
- **Zero if and only if**: $P=Q$ almost everywhere.
`;

export default klDivergence;